import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0171',
    ecrans: ['00-2']
});
